import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import cs from 'classnames';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
function FooterSlogan(props = {}) {
  const {
    className,
    ...restProps
  } = props;
  const t = useLocale(locale);
  return /*#__PURE__*/React.createElement(_Layout.Footer, _extends({
    className: cs(styles.footer, className)
  }, restProps), t['slogan']);
}
export default FooterSlogan;